import { InjectionToken } from "@angular/core";

export const DEFINED_BUSINESS_ERROR_CODE_TYPE = new InjectionToken<any>('DEFINED_BUSINESS_ERROR_CODE_TYPE');
export const APIM_FILTERS = new InjectionToken<string[]>('APIM_FILTERS');
